export const AGENCY_MARKETS = [
  'I',
  'A',
  'B',
  'D',
  'GB',
  'E',
  'RA',
  'FI',
  'F',
  'P',
  'USA',
  'BR',
  'CH',
  'PL',
  'CZ',
  'SK',
  'HR',
  'OL',
  'NL',
  'CIS',
  'HK',
  'JP',
  'AU',
  'EU',
  'MED',
] as const;

export type AgencyMarket = (typeof AGENCY_MARKETS)[number];

export function normalizeAgencyMarket(market: string | null | undefined): AgencyMarket | undefined {
  const normalizedMarket = market?.trim().toUpperCase();
  if (!normalizedMarket) return undefined;

  return AGENCY_MARKETS.includes(normalizedMarket as AgencyMarket)
    ? (normalizedMarket as AgencyMarket)
    : undefined;
}
